import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import PhosphorIconInit from "./helper/PhosphorIconInit";
import HomePageCustomer from "./pagesAmazon/customer/HomePageCustomer";
import AccountPageAmazon from "./pagesAmazon/Account/AccountPageAmazon";
import BecomeSellerPageAmazon from "./pagesAmazon/Account/BecomeSellerPageAmazon";
import ProtectedRoute from "./ProtectedRoute";
import ShopPageAmazon from "./pagesAmazon/Shop/ShopPageAmazon";
import ProfileVendorAmazon from "./pagesAmazon/ProfileVendorAmazon";
import ProfileCustomerAmazon from "./pagesAmazon/ProfileCustomerAmazon";
import TopUpAmazon from "./pagesAmazon/TopUpAmazon";
 import WholesaleCenterAmazon from "./pagesAmazon/WholesaleCenterAmazon";
import ReturnedProductAmazon from "./pagesAmazon/Shop/ReturnedProductAmazon";
import CartPageAmazon from "./pagesAmazon/CartPageAmazon";
import CheckoutPageAmazon from "./pagesAmazon/CheckoutPageAmazon";
import WholesaleCenterDetailsAmazon from "./pagesAmazon/WholesaleCenterDetailsAmazon";
import ShopPageDetailsAmazon from "./pagesAmazon/Shop/ShopPageDetailsAmazon";
import HomePageDetailsAmazon from "./pagesAmazon/Shop/HomePageDetailsAmazon";
import WishlistPageAmazon from "./pagesAmazon/WishlistPageAmazon";
import ComparePageAmazon from "./pagesAmazon/ComparePageAmazon";
  import PendingOrderVendor from "./pagesAmazon/PendingOrderVendor";
  import PendingOrderCustomer from "./pagesAmazon/PendingOrderCustomer";

import VendorStorePage from "./pagesAmazon/customer/VendorStorePage";
import ProductSampleStorePage from "./pagesAmazon/customer/ProductSampleStorePage";
import HomePageDetailsSampleAmazon from "./pagesAmazon/Shop/HomePageDetailsSampleAmazon";
import DashboardVendor from "./pagesAmazon/DashboardVendor";
import DashbordCustomer from "./pagesAmazon/DashbordCustomer";
import WholesaleCenterProductsDetails from "./pagesAmazon/WholesaleCenterProductsDetails";
import FooterCompanyProfile from "./pagesAmazon/FooterCompanyProfile";
import FooterMerchantCenter from "./pagesAmazon/FooterMerchantCenter";
import FooterRulesPolicy from "./pagesAmazon/FooterRulesPolicy";
import FooterOurSuppliers from "./pagesAmazon/FooterOurSuppliers";
import TermConditionamazon from "./pagesAmazon/TermConditionamazon";
 function App() {
   return (
    <BrowserRouter>
      <RouteScrollToTop />
      <PhosphorIconInit />
 
      <Routes>
      {/* Your routes */}
         <Route exact path='/' element={<HomePageCustomer />} />
  
        <Route
          path="/vendor/:id"
          element={
               <VendorStorePage />
           }
        />
         <Route
          path="/displays-category/:id"
          element={
               <ProductSampleStorePage />
           }
        />
        
        <Route exact path='/become-seller' element={<BecomeSellerPageAmazon />} />
        <Route exact path='/compony-profile' element={<FooterCompanyProfile />} />
        <Route exact path='/marchant-center' element={<FooterMerchantCenter />} />
        <Route exact path='/rules-regulations' element={<FooterRulesPolicy />} />
        <Route exact path='/our-suppliers' element={<FooterOurSuppliers />} />
        <Route exact path='/term-conditions' element={<TermConditionamazon />} />

        <Route exact path='/account' element={<AccountPageAmazon/>} />

        <Route
          path="/cart"
          element={
            <ProtectedRoute roles={['ROLE_CUSTOMER']}>
              <CartPageAmazon />
            </ProtectedRoute>
          }
        /> 
         <Route
          path="/compare-list"
          element={
            <ProtectedRoute roles={['ROLE_CUSTOMER']}>
              <ComparePageAmazon />
            </ProtectedRoute>
          }
        /> 
         <Route
          path="/wishlist"
          element={
            <ProtectedRoute roles={['ROLE_CUSTOMER']}>
              <WishlistPageAmazon />
            </ProtectedRoute>
          }
        /> 
   {/* Protected Vendor Routes */}
        <Route
          path="/shop"
          element={
            <ProtectedRoute roles={['ROLE_VENDER']}>
              <ShopPageAmazon />
            </ProtectedRoute>
          }
        />
        <Route
          path="/shop-product-details"
          element={
            <ProtectedRoute roles={['ROLE_ADMIN','ROLE_VENDER']}>
              <ShopPageDetailsAmazon />
            </ProtectedRoute>
          }
        />
         <Route
          path="/detail-product"
          element={
               <HomePageDetailsAmazon />
           }
        />
          <Route
          path="/product-detail-sample"
          element={
               <HomePageDetailsSampleAmazon />
           }
        />
         <Route
          path="/returned-product"
          element={
            <ProtectedRoute roles={['ROLE_ADMIN','ROLE_VENDER']}>
              <ReturnedProductAmazon />
            </ProtectedRoute>
          }
        />  
        
        <Route
          path="/vendor-profile"
          element={
            <ProtectedRoute roles={['ROLE_ADMIN','ROLE_VENDER']}>
              <ProfileVendorAmazon />
            </ProtectedRoute>
          }
        /> 

         <Route
          path="/wholesale-center"
          element={
            <ProtectedRoute roles={['ROLE_ADMIN','ROLE_VENDER']}>
              <WholesaleCenterAmazon />
            </ProtectedRoute>
          }
        /> 
         <Route
          path="/wholesale-center-details"
          element={
            <ProtectedRoute roles={['ROLE_ADMIN','ROLE_VENDER']}>
              <WholesaleCenterDetailsAmazon />
            </ProtectedRoute>
          }
        /> 
         <Route
          path="/wholesale-center-products-returned"
          element={
            <ProtectedRoute roles={['ROLE_ADMIN','ROLE_VENDER']}>
              <WholesaleCenterProductsDetails />
            </ProtectedRoute>
          }
        /> 
         <Route
          path="/wallet"
          element={
            <ProtectedRoute roles={['ROLE_ADMIN','ROLE_VENDER','ROLE_CUSTOMER']}>
              <TopUpAmazon />
            </ProtectedRoute>
          }
        /> 

         <Route
          path="/checkout"
          element={
            <ProtectedRoute roles={['ROLE_ADMIN','ROLE_VENDER','ROLE_CUSTOMER']}>
              <CheckoutPageAmazon />
            </ProtectedRoute>
          }
        /> 
         <Route
          path="/dashboard-customer"
          element={
            <ProtectedRoute roles={['ROLE_CUSTOMER']}>
              <DashbordCustomer />
            </ProtectedRoute>
          }
        /> 
         <Route
          path="/dashboard-vendor"
          element={
            <ProtectedRoute roles={['ROLE_VENDER']}>
              <DashboardVendor />
            </ProtectedRoute>
          }
        /> 
        <Route
          path="/customer-orders"
          element={
            <ProtectedRoute roles={['ROLE_ADMIN','ROLE_CUSTOMER']}>
              <PendingOrderCustomer />
            </ProtectedRoute> 
          }
        /> 

        <Route
          path="/vendor-orders"
          element={
            <ProtectedRoute roles={['ROLE_ADMIN','ROLE_VENDER']}>
              <PendingOrderVendor />
            </ProtectedRoute>
          }
        /> 
          
         <Route
          path="/profile"
          element={
            <ProtectedRoute roles={['ROLE_ADMIN','ROLE_CUSTOMER']}>
              <ProfileCustomerAmazon />
            </ProtectedRoute>
          }
        /> 
     {/* Redirect unknown routes to login if not authenticated */}
     <Route path="*" element={<Navigate to={"/"} />} />
      
      </Routes>
    </BrowserRouter>
  );
}

export default App;
